import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const HeadWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 14px;
	color: ${colors.black};
`;

export const Filter = styled.div``;
